/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChannelListRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA70lEQVR4nO1Tyw4BQRDcf0AcfBBhu7scVreDP+AiLq5u/khCSIjPwcFB4kJmRbLeO+yFqGSSSWema6aqOgj+SAuCLRl2yGSJLm4IXDErAoLNg98D/T34Pg/kTtafwXcO6GeyTnWrEHTE0DWJbRk2EWmUY8mTMqbyQC51Z9jg1R0vDyihu0izGtdE9wzthmEzX6tFJYL1T7UrAm9pYONTE+0+U+F9ArGVa+Be/kiFi6T5esDQtasBrVyqF/l6QLDZtUSZgtn4bHIo2iOyYiWKCvEeuiFo+3MS6PDhb8U6mfyEoEKwaRxN0Z1Llxu+84Ej8deTY4gKsnYAAAAASUVORK5CYII=)
 */
export const ChannelListRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M3 3a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2H3ZM19 16a3 3 0 1 0 1.98 5.25 1 1 0 1 1 1.33 1.5A4.98 4.98 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h1.24A3 3 0 0 0 19 16ZM2 8a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 11a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2H3ZM2 16a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 19a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H3Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
